<div class="row">
  <div class="col-md-12 text-center">
    <i class="fal fa-spinner-third fa-spin"></i> {{message}}
  </div>
</div>